export const layoutHeader = {
  refreshBtn: {
    label: 'Rafraichir',
  },
  loginBtn: {
    label: 'Se connecter',
  },
  logoutBtn: {
    label: 'Se déconnecter',
  },
};
